import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";
import { useToast } from "vue-toastification";
import qs from "querystring";
import { useRouter, useRoute } from "vue-router";

export interface User {
  name: string;
  surname: string;
  email: string;
  password: string;
  token: string;
  username: string;
  active: boolean;
  companyId: string;
  companyName: string;
  dateOfBirth: string;
  userId: string;
  role: Array<string>;
  roleContoh: string;
  phone: string;
  lang: string;
  isWa: boolean;
  isFirstLogin: boolean;
  isAdmin: boolean;
  image: string;
  access_token: string;
  showLogin: boolean;
  initial: string;
}
export interface Address {
  province: string;
  city: string;
  district: string;
  village: string;
  address: string;
  postCode: string;
}

export interface UserAuthInfo {
  errors: Array<string>;
  user: User;
  isAuthenticated: boolean;
}
export interface Notif {
  notif: string;
}
export interface TabRegistrasi {
  tabActive: number;
}

@Module
export default class AuthModule extends VuexModule implements UserAuthInfo {
  errors = [];
  user = {} as User;
  address = {} as Address;
  tabRegistes = {} as TabRegistrasi;
  isAuthenticated = !!JwtService.getToken();

  /**
   * Get current user object
   * @returns User
   */
  get currentUser(): User {
    return this.user;
  }
  get getAddress(): Address {
    return this.address;
  }
  /**
   * Verify user authentication
   * @returns boolean
   */
  get isUserAuthenticated(): boolean {
    return this.isAuthenticated;
  }

  /**
   * Get authentification errors
   * @returns array
   */
  get getErrors(): Array<string> {
    return this.errors;
  }

  @Mutation
  [Mutations.SET_SHOWLOGIN](showLogin) {
    this.user.showLogin = showLogin;
  }
  @Mutation
  [Mutations.SET_INITIAL](initial) {
    this.user.initial = initial;
  }

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = error;
  }
  @Mutation
  [Mutations.SET_NOTIF](error) {
    console.log(error);
  }

  @Mutation
  [Mutations.SET_AUTH](token) {
    this.isAuthenticated = true;
    // this.user = user;
    if (typeof token == "object") {
      token = token.access_token;
    }
    this.errors = [];
    if (token) JwtService.saveToken(token);
  }

  @Mutation
  [Mutations.SET_USER](user) {
    this.user = user;
  }

  @Mutation
  [Mutations.SET_ADDRESS](address) {
    this.address = address;
  }

  @Mutation
  [Mutations.SET_PASSWORD](password) {
    this.user.password = password;
  }

  @Mutation
  [Mutations.PURGE_AUTH]() {
    this.isAuthenticated = false;
    this.user = {} as User;
    this.errors = [];
    JwtService.destroyToken();
  }

  // @Mutation
  // [Mutations.CHANGE_TAB](cek) {
  // console.log(cek)
  //  this.tabRegistes.tabActive = cek

  // }
  @Action
  [Actions.LOGIN](credentials) {
    return new Promise<void>((resolve, reject) => {
      var toast = useToast();
      ApiService.postlogin("auth/all/login", qs.stringify(credentials ?? credentials.values))
        .then(({ data }) => {
          if (data.role !== "STUDENT") {
            this.context.commit(
              Mutations.SET_ERROR,
              "Role tidak memiliki Akses"
            );
            reject();
          } else {
            this.context.commit(Mutations.SET_AUTH, data);

            ApiService.getWithoutSlug(
              "https://api.katalis.info/wilayah/getAllProvinces"
            ).then((response) => {
              localStorage.setItem("provinces", JSON.stringify(response.data));
            });
            localStorage.setItem("user_account", JSON.stringify(data));

            resolve();
          }
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data.detail);
          reject();
        });
    });
  }

  @Action
  [Actions.SHOW_LOGIN](data) {
    this.context.commit(Mutations.SET_SHOWLOGIN, data);
  }

  @Action
  [Actions.LOGOUT]() {
    this.context.commit(Mutations.PURGE_AUTH);
    localStorage.clear();
  }

  @Action
  [Actions.REGISTER](credentials) {
    return new Promise<void>((resolve, reject) => {
      ApiService.post("main_auth/auth/register", qs.stringify(credentials))
        .then(({ data }) => {
          this.context.commit(Mutations.SET_AUTH, data);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data.detail);
          reject();
        });
    });
  }

  @Action
  [Actions.FORGOT_PASSWORD](payload) {
    return new Promise<void>((resolve, reject) => {
      ApiService.post("forgot_password", payload)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_AUTH, data);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data.detail);
          reject();
        });
    });
  }

  @Action
  [Actions.CEK_INITIAL]() {
    const toast = useToast();
    const router = useRouter();

    if (
      JSON.parse(localStorage.getItem("company")!).crmData.initial === null ||
      JSON.parse(localStorage.getItem("company")!).crmData.initial === "" ||
      JSON.parse(localStorage.getItem("company")!).crmData.initial === undefined
    ) {
      this.context.commit(Mutations.SET_SHOWLOGIN, false);
      this.context.commit(Mutations.SET_INITIAL, "");
    } else {
      this.context.commit(Mutations.SET_SHOWLOGIN, true);
      this.context.commit(
        Mutations.SET_INITIAL,
        JSON.parse(localStorage.getItem("company")!).crmData.initial
      );
    }
  }
  @Action
  [Actions.CEK_COMPANY]() {
    const toast = useToast();
    const router = useRouter();

    if (
      JSON.parse(localStorage.getItem("company")!) === null ||
      JSON.parse(localStorage.getItem("company")!) === "" ||
      JSON.parse(localStorage.getItem("company")!) === undefined
    ) {
      localStorage.setItem("company", "{}");
    }
  }
  @Action
  [Actions.VERIFY_AUTH]() {
    console.log("verify");
    const toast = useToast();
    const router = useRouter();

    if (JwtService.getToken()) {
      ApiService.setHeader();
      ApiService.getExternalAuthPpdb("ppdb/v2/auth/all/user_check")
        .then(({ headers, data }) => {
          // console.log(data);
          let authorization;
          authorization = data.access_token;
          if (headers.authorization) authorization = headers.authorization;
          this.context.commit(Mutations.SET_AUTH, authorization);
        })
        .catch(({ response }) => {
          toast.error(response.data.detail);

          router.push("/sign-in/ppdb");

          this.context.commit(Mutations.SET_ERROR, response.data.detail);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.VERIFY_AUTH_USER]() {
    const toast = useToast();
    const router = useRouter();

    if (JwtService.getToken()) {
      ApiService.setHeader();
      ApiService.postWithoutSlug("auth/all/refresh_token")
        .then(({ data }) => {
          this.context.commit(Mutations.SET_AUTH, data);
        })
        .catch(({ response }) => {
          toast.error(response.data.detail);

          router.push("/sign-in/ppdb");

          this.context.commit(Mutations.SET_ERROR, response.data.detail);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.VERIFY_AUTH_NOTIFIKASI]() {
    const toast = useToast();
    const router = useRouter();

    if (JwtService.getToken()) {
      ApiService.setHeader();
      ApiService.postWithoutSlug("credential/refresh_token")
        .then(({ data }) => {
          this.context.commit(Mutations.SET_AUTH, data);
        })
        .catch(({ response }) => {
          toast.error(response.data.detail);

          router.push("/sign-in/ppdb");

          this.context.commit(Mutations.SET_ERROR, response.data.detail);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.UPDATE_USER](payload) {
    ApiService.setHeader();
    return new Promise<void>((resolve, reject) => {
      ApiService.post("update_user", payload)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_USER, data);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data.errors);
          reject();
        });
    });
  }
  @Action
  [Actions.SEND_ADDRESS](payload) {
    localStorage.setItem("studentAddress", JSON.stringify(payload));
    this.context.commit(Mutations.SET_ADDRESS, payload);
  }
  @Action
  [Actions.NOTIFIKASI](cek) {
    const toast = useToast();
    const router = useRouter();

    var a = JSON.parse(localStorage.getItem("badgeNotiflegal")!);
    var b = a - 1;
    console.log(cek, a);
  }
}
